// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
export * from "./inspect.common.js";
//# sourceMappingURL=inspect-browser.mjs.map